/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useContext as t,useState as o,useEffect as n}from"react";import{motionValue as i}from"./index.js";import{MotionConfigContext as r}from"../context/MotionConfigContext.js";import{useConstant as s}from"../utils/use-constant.js";function c(c){const e=s((()=>i(c))),{isStatic:m}=t(r);if(m){const[,t]=o(c);n((()=>e.on("change",t)),[])}return e}export{c as useMotionValue};
//# sourceMappingURL=use-motion-value.js.map
